// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CancelReasonForm-cancelReasonLabel-qGmcT {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    color: var(--primary-foreground);
    margin-bottom: 0 !important;
    cursor: pointer;
}

.CancelReasonForm-cancelReasonLabelContainer-oI_9k {
    display: grid;
    gap: 12px;
    grid-gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/CancelReasonForm/CancelReasonForm.css"],"names":[],"mappings":"AAAA;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB","sourcesContent":[".cancelReasonLabel {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    color: var(--primary-foreground);\n    margin-bottom: 0 !important;\n    cursor: pointer;\n}\n\n.cancelReasonLabelContainer {\n    display: grid;\n    gap: 12px;\n    grid-gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cancelReasonLabel": `CancelReasonForm-cancelReasonLabel-qGmcT`,
	"cancelReasonLabelContainer": `CancelReasonForm-cancelReasonLabelContainer-oI_9k`
};
module.exports = ___CSS_LOADER_EXPORT___;
